import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonItemGroup,
  IonItem,
  IonLabel,
  useIonModal,
  useIonToast,
  IonicSafeString,
  useIonAlert,
  IonSelect,
  IonSelectOption,
} from "@ionic/react";
import React, { useState } from "react";
import { useContext } from "react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "../components/AppContext";
import UpdateLog from "../components/UpdateLog";

const About: React.FC = () => {
  const pageRef = useRef(null);
  const { store } = useContext(AppContext);
  const { t, i18n } = useTranslation();
  const [presentUpdate, dismissUpdate] = useIonModal(UpdateLog, {
    dismissUpdate: () => dismissUpdate(),
  });
  const [currentLng, setCurrentLng] = useState(i18n.language);
  const [presentDeleteAction, dismissDeleteAction] = useIonAlert();
  const [presentToast, dismissToast] = useIonToast();
  const clearStorage = async () => {
    await store.clear();
  };
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setCurrentLng(lng);
  };
  return (
    <IonPage ref={pageRef}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{t("About")}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{t("About")}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <div className="m-4">
          <IonItemGroup className="item-group-input !bg-transparent">
            <IonItem>
              <div className="pt-2 flex gap-4 flex-grow">
                <img
                  src="/assets/favicon/android-chrome-512x512.png"
                  alt="app logo"
                  className="w-16 h-16 rounded-xl bg-white dark:bg-gray-900 overflow-hidden flex-shrink-0"
                />
                <div className="flex-grow">
                  <h2 className="font-semibold">{t(`Code Artist`)}</h2>
                  <p className="text-sm pt-1">{t(`App.description`)}</p>
                </div>
              </div>
            </IonItem>
            <IonItem className="item-input">
              <IonLabel>{t(`Author`)}</IonLabel>
              <IonLabel slot="end">Oliver Pan</IonLabel>
            </IonItem>
            <IonItem className="item-input">
              <IonLabel>{t(`Version`)}</IonLabel>
              <IonLabel slot="end">V4.0.2</IonLabel>
            </IonItem>
          </IonItemGroup>

          <IonItemGroup className="item-group-input !bg-transparent !mt-4">
            <IonItem className="item-input">
              <IonLabel>{t(`Language`)}</IonLabel>
              <IonSelect
                slot="end"
                value={currentLng}
                defaultValue={currentLng}
                onIonChange={(e) => changeLanguage(e.detail.value)}
              >
                <IonSelectOption value={"en-US"}>English (US)</IonSelectOption>
                <IonSelectOption value={"zh-CN"}>中文</IonSelectOption>
                {/* <IonSelectOption value={"zh-TW"}>繁體</IonSelectOption> */}
              </IonSelect>
            </IonItem>
          </IonItemGroup>

          <IonItemGroup className="item-group-input !bg-transparent !mt-4">
            <IonItem
              button
              detail
              className="item-input"
              onClick={() => {
                presentUpdate({
                  presentingElement: pageRef.current,
                  swipeToClose: true,
                });
              }}
            >
              <IonLabel>{t(`Updates`)}</IonLabel>
            </IonItem>
            <IonItem routerLink="/privacy" detail button>
              <IonLabel>{t(`Privacy Policy`)}</IonLabel>
            </IonItem>
            <IonItem routerLink="/terms" detail button>
              <IonLabel>{t(`Terms of Service`)}</IonLabel>
            </IonItem>
          </IonItemGroup>
          <IonItemGroup className="item-group-input !bg-transparent !mt-4">
            <IonItem
              onClick={() =>
                //@ts-ignore
                presentDeleteActipon({
                  header: t(`Erase Storage`),
                  message: new IonicSafeString(t(`eraseStorageMessage`)),
                  buttons: [
                    { text: "Cancel", handler: dismissDeleteAction },
                    {
                      text: "Delete",
                      role: "destructive",
                      handler: async () =>
                        await clearStorage().then(() =>
                          presentToast("Storage & settings are cleared", 2800)
                        ),
                    },
                  ],
                })
              }
              button
              detail={false}
            >
              <IonLabel color="danger">
                {t(`Clear storage & settings...`)}
              </IonLabel>
            </IonItem>
          </IonItemGroup>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default About;
